(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.product-card-tailwind');
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.remove('opacity-0', 'translate-y-5');
        card.classList.add('opacity-100', 'translate-y-0');
      }, 100 * index);

      const title = card.querySelector('h2, h3');
      if (title) {
        const lh = parseFloat(getComputedStyle(title).lineHeight) || 26;
        if (title.scrollHeight > lh * 1.5) {
          title.style.fontSize = '1.3rem';
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
